import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ic_club",
  "use": "icon-ic_club-usage",
  "viewBox": "0 0 100 125",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 100 125\" id=\"icon-ic_club\">\n<style type=\"text/css\">\n\t#icon-ic_club .st0{stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M94.2,19.4C76.8,19.1,67.4,11.3,65,9c-1.2-1.1-3-1.1-4.2,0C58.4,11.4,49,19.1,31.6,19.5\n\t\tc-1.6,0.1-2.9,1.4-2.9,3v22.1c0,15.5,7,30.2,18.6,39.3c4.4,3.5,9.4,6.1,14.7,7.8h1.8c5.3-1.7,10.3-4.3,14.7-7.8\n\t\tc11.6-9.1,18.6-23.8,18.6-39.3V22.4C97.1,20.8,95.8,19.5,94.2,19.4z\" />\n</g>\n<title>15</title>\n<g>\n\t<path class=\"st0\" d=\"M65.5,39.4C48.1,39.1,38.7,31.3,36.3,29c-1.2-1.1-3-1.1-4.2,0c-2.4,2.4-11.8,10.1-29.2,10.5\n\t\tc-1.6,0.1-2.9,1.4-2.9,3v22.1c0,15.5,7,30.2,18.6,39.3c4.4,3.5,9.4,6.1,14.7,7.8h1.8c5.3-1.7,10.3-4.3,14.7-7.8\n\t\tc11.6-9.1,18.6-23.8,18.6-39.3V42.4C68.4,40.8,67.1,39.5,65.5,39.4z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/ic_club.svg
// module id = DKu2
// module chunks = 1